// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__uy70C","position":"style_position__10gL9","form":"style_form__sp+mY"};